import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";
import BaseService from "./base.service";

export default class ExportedContentsService extends BaseService {
  searchPlan = (data) => {
    return this.axios.post(API_ENDPOINTS.EXPORTED_CONTENTS_PLAN_SEARCH, data);
  };

  fetchPlanExportRows = (data) => {
    return this.axios.post(API_ENDPOINTS.EXPORTED_CONTENTS_PLAN_EXPORT_ROWS, data);
  };

  searchExecution = (data) => {
    return this.axios.post(API_ENDPOINTS.EXPORTED_CONTENTS_EXECUTION_SEARCH, data);
  };

  fetchExecutionExportRows = (data) => {
    return this.axios.post(API_ENDPOINTS.EXPORTED_CONTENTS_EXECUTION_EXPORT_ROWS, data);
  };
}
